function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M42.39 42.39H7.61C6.17 42.39 5 41.22 5 39.78V15.43c0-1.44 1.17-2.61 2.61-2.61h34.78c1.44 0 2.61 1.17 2.61 2.61v24.35c0 1.44-1.17 2.61-2.61 2.61zM7.61 14.57a.87.87 0 00-.87.87v24.35c0 .48.39.87.87.87h34.78c.48 0 .87-.39.87-.87V15.43a.87.87 0 00-.87-.87H7.61z",
  fill: "#fff"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M30.22 14.57H19.78a.87.87 0 01-.87-.87v-3.48c0-1.44 1.17-2.61 2.61-2.61h6.96c1.44 0 2.61 1.17 2.61 2.61v3.48c0 .48-.39.87-.87.87zm-9.57-1.74h8.7v-2.61a.87.87 0 00-.87-.87h-6.96a.87.87 0 00-.87.87v2.61zM25 37.17c-5.27 0-9.57-4.29-9.57-9.57s4.29-9.57 9.57-9.57c5.27 0 9.57 4.29 9.57 9.57s-4.3 9.57-9.57 9.57zm0-17.39c-4.32 0-7.83 3.51-7.83 7.83s3.51 7.83 7.83 7.83 7.83-3.51 7.83-7.83-3.51-7.83-7.83-7.83z",
  fill: "#fff"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M26.74 33.7h-3.48a.87.87 0 01-.87-.87v-2.61h-2.61a.87.87 0 01-.87-.87v-3.48c0-.48.39-.87.87-.87h2.61v-2.61c0-.48.39-.87.87-.87h3.48c.48 0 .87.39.87.87V25h2.61c.48 0 .87.39.87.87v3.48c0 .48-.39.87-.87.87h-2.61v2.61c0 .48-.39.87-.87.87zm-2.61-1.74h1.74v-2.61c0-.48.39-.87.87-.87h2.61v-1.74h-2.61a.87.87 0 01-.87-.87v-2.61h-1.74v2.61c0 .48-.39.87-.87.87h-2.61v1.74h2.61c.48 0 .87.39.87.87v2.61z",
  fill: "#fff"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 50 50"
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/health.13eac691.svg";
export { SvgComponent as ReactComponent };